const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Transcode Jobs for Videos
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Transcode', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/v3/transcoding-job', null, {
      transcodeJob: {params: {}, method: 'POST', isArray: false}
    });
  }]);
